import {
	COOKIE_LANGUAGE_KEY,
	COOKIE_CATALOG_ID_KEY,
	COOKIE_CATALOG_NAME_KEY,
	CATALOG_NAMES
} from '@/constants/ui.constants'
import { getURL } from './env.utils'

const COOKIE_DOMAIN = `.${getURL('', '').replace(/^https?:\/\//, '')}`

console.log("SEARCHING COOKIES IN ", COOKIE_DOMAIN)

export const setCookie = (key, value) => {
	let newDate = new Date()
	newDate.setTime(newDate.getTime() + (30 * 24 * 60 * 60 * 1000))
	document.cookie = `${key}=${value};path=/;domain=${COOKIE_DOMAIN};expires=${newDate.toUTCString()};`
}

export const cleanCookie = (key) => {
	document.cookie = `${key}=;path=/;domain=${COOKIE_DOMAIN};max-age=0;`
}

export const getCookie = (key) => {
	const cookies = document.cookie
		.split(';')
		.filter((c) => !!c)
		.map((c) => {
			const [name, value] = c.split('=').map((el) => el.trim())
			return { name, value }
		})

	return cookies.find((c) => c.name === key)?.value || null
}

export const setLanguageCookie = (language) => {
	setCookie(COOKIE_LANGUAGE_KEY, language)
}

export const setCatalogIdCookie = (catalogId) => {
	setCookie(COOKIE_CATALOG_ID_KEY, catalogId)
}

export const setCatalogNameCookie = (catalogId) => {
	setCookie(COOKIE_CATALOG_NAME_KEY, CATALOG_NAMES[catalogId].toLowerCase())
}
